/**
 * FiltersBar — client-only view filters (no reload).
 */
import { Sparkles, Activity, OctagonX, Target, CheckCircle2, Filter } from "lucide-react";

const OPTIONS = [
    { id: "ALL",           label: "All",             Icon: Filter },
    { id: "ACTIVE",        label: "Active",          Icon: Activity },
    { id: "BLOCKERS",      label: "Blockers",        Icon: OctagonX },
    { id: "LAUNCH",        label: "Launch Critical", Icon: Target },
    { id: "COMPLETED",     label: "Completed",       Icon: CheckCircle2 },
];

export default function FiltersBar({ value, onChange, onLaunchLens }) {
    return (
        <div data-testid="gtm-filters-bar" className="flex flex-wrap items-center gap-2">
            {OPTIONS.map((o) => {
                const active = value === o.id;
                const Icon = o.Icon;
                return (
                    <button
                        key={o.id}
                        type="button"
                        data-testid={`gtm-filter-${o.id.toLowerCase()}`}
                        onClick={() => onChange(o.id)}
                        aria-pressed={active}
                        className={`inline-flex items-center gap-1.5 h-8 px-3 rounded-full border font-mono-ui text-[10px] tracking-widest uppercase transition-colors qoryn-focus ${
                            active
                                ? "bg-qoryn-cyan/10 text-qoryn-cyan border-qoryn-cyan/40"
                                : "text-qoryn-textDim border-qoryn-border/70 hover:text-qoryn-text hover:bg-white/[0.04]"
                        }`}
                    >
                        <Icon className="h-3 w-3" strokeWidth={1.75} />
                        {o.label}
                    </button>
                );
            })}
            <div className="flex-1" />
            <button
                type="button"
                data-testid="gtm-launch-lens-btn"
                onClick={onLaunchLens}
                className="inline-flex items-center gap-2 h-9 px-4 rounded-full border border-qoryn-cyan/40 bg-qoryn-cyan/[0.08] text-qoryn-cyan font-mono-ui text-[10px] tracking-widest uppercase hover:brightness-125 transition-all qoryn-focus"
            >
                <Sparkles className="h-3 w-3" strokeWidth={1.75} />
                What stands between us and launch?
            </button>
        </div>
    );
}
